import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography } from "antd";
import { isString } from "lodash";
/**
 * Displays the name of the organization.
 * Usage: `<TopbarContent.OrganizationName organization={organization} />`
 */
export const OrganizationName = ({ organization }) => {
    return (_jsx(Typography.Title, { level: 5, type: "secondary", style: { margin: 0, whiteSpace: "nowrap" }, children: organization.name || "" }));
};
/**
 * Displays the logo of the organization, if it exists.
 * Usage: `<TopbarContent.OrganizationLogo organization={organization} />`
 */
export const OrganizationLogo = ({ organization }) => {
    return isString(organization.customerLogo) &&
        organization.customerLogo.length > 0 ? (_jsx("img", { alt: "", src: organization.customerLogo, height: "32px" })) : (_jsx(_Fragment, {}));
};
